import restApi from "@plannel/services/utils/rest-api";

const getAll = params => {
  return restApi.post("/api/npi-profile-master", params);
};

const getAllForCSV = params => {
  return restApi.post("/api/npi-profile-master/csv", params);
};

const upsert = data => {
  return restApi.post("/api/npi-profile-master/save", data);
};

const remove = ids => {
  return restApi.delete(`/api/npi-profile-master/${ids}`);
};

const npiProfileMasterService = {
  getAll,
  getAllForCSV,
  upsert,
  remove
};

export default npiProfileMasterService;
